import { render } from "./AppHeaderDropdownAccnt.vue?vue&type=template&id=0c19bbba"
import script from "./AppHeaderDropdownAccnt.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdownAccnt.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2653157369/src/mchanga-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__